import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#338AF3\" d=\"M12 8.869h11.587a12 12 0 0 0-1.348-3.13H12zM4.53 21.39h14.94a12 12 0 0 0 2.77-3.13H1.761a12 12 0 0 0 2.769 3.13M12-.001v2.609h7.47A11.95 11.95 0 0 0 12-.001\"></path><path fill=\"#338AF3\" d=\"M12 8.869h11.587a12 12 0 0 0-1.348-3.13H12zM0 12c0 1.083.144 2.132.413 3.13h23.174c.269-.998.413-2.047.413-3.13z\"></path><path fill=\"#FFDA44\" d=\"m10.435 7.023-1.466.69.78 1.419-1.59-.304-.202 1.607-1.109-1.182-1.108 1.182-.202-1.607-1.591.304.78-1.42-1.465-.689 1.465-.69-.78-1.418 1.591.304.202-1.608 1.108 1.183L7.957 3.61l.201 1.608 1.592-.304-.78 1.419z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }